<template>
  <div class="cmzDetail">
    <el-button class="fixed-back-btn" @click="$router.go(-1)">返回</el-button>
    <div class="headTitle" style="margin-top: 0">
      <img src="@static/images/base.png" alt="" />
      <span>客户基本信息</span>
    </div>
    <div class="card">
      <div class="row">
        <div class="cell">
          <span>客户姓名</span>
          <span>{{ detailDate.userName }}</span>
        </div>
        <div class="cell">
          <span>性别</span>
          <span>{{ detailDate.sex == 1 ? "男" : "女" }}</span>
        </div>
        <div class="cell">
          <span>手机号码</span>
          <span>{{ detailDate.rmobile||"-" }}</span>
        </div>
        <div class="cell">
          <span>微信号</span>
          <span>{{ detailDate.wechat||"-" }}</span>
        </div>
        <div class="cell">
          <span>购买方案</span>
          <span>{{ detailDate.planName||"-" }}</span>
        </div>
        <div class="cell">
          <span>支付状态</span>
          <span>{{ detailDate.payStatus ? "已支付" : "待支付" }}</span>
        </div>
        <div class="cell">
          <span>信息完善</span>
          <span>{{ detailDate.orderStatus >= 3 ? "已完善" : "未完善" }}</span>
        </div>
        <div class="cell">
          <span>既往病历</span>
          <span>{{ detailDate.anamnesis||"-" }}</span>
        </div>
        <div class="cell">
          <span>居住地</span>
          <span>{{ detailDate.address||"-" }}</span>
        </div>
        <div class="cell">
          <span>家庭收入</span>
          <span>{{ detailDate.familyIncomes||"-" }}</span>
        </div>
        <div class="cell">
          <span>来源</span>
          <span>{{ detailDate.title||all.SUBSCRIBE_SOURCE[detailDate.source]||"-" }}</span>
        </div>
      </div>
    </div>
    <div class="headTitle">
      <img src="@static/images/base02.png" alt="" />
      <span>被保人信息</span>
    </div>
    <div
      class="card"
      v-for="(item, index) in infoDetail.insuredInfoList"
      :key="index"
    >
      <div class="row">
        <div class="cell">
          <span>与投保人关系</span>
          <span>{{ item.relationShip||"-" }}</span>
        </div>
        <div class="cell">
          <span>被保人年龄</span>
          <span>{{ item.age||"-" }}</span>
        </div>
        <div class="cell">
          <span>有无社保</span>
          <span>{{ item.hasSocialSecurity == 1 ? "有" : "无" }}</span>
        </div>
        <div class="cell">
          <span>既往病历</span>
          <span>{{ item.anamnesis||"-" }}</span>
        </div>
        <div class="cell">
          <span>职业类型</span>
          <span>{{ item.job||"-" }}</span>
        </div>
        <div class="cell">
          <span>生活状态</span>
          <span>{{ item.lifeCondition||"-" }}</span>
        </div>
      </div>
    </div>
    <emptyBox v-if="infoDetail.insuredInfoList&&infoDetail.insuredInfoList.length==0"></emptyBox>
    <div class="headTitle">
      <img src="@static/images/base03.png" alt="" />
      <span>客户跟进记录</span>
    </div>
    <div class="recored">
      <div
        class="item"
        :class="{ active: index == 0,hideLine: serviceRecordArr.length==0}"
        v-for="(item, index) in serviceRecordArr"
        :key="index"
      >
        <div class="dot"></div>
        <div class="time">{{ item.createTime }}</div>
        <div class="status">{{ item.serviceDesc }}</div>
      </div>
      <div
        class="item hideLine"
        :class="{active:serviceRecordArr.length==0}"
      >
        <div class="dot"></div>
        <div class="time">{{ detailDate.createTime }}</div>
        <div class="status">坐席安排：专业坐席顾问{{ detailDate.serverName }}</div>
      </div>
    </div>
  </div>
</template>
<script>
var vm;
var QRCode = require("qrcode");
import Clipboard from "clipboard";
import { Loading } from "element-ui";
import commom from "../../api/common";
export default {
  data: () => ({
    plandz: "",
    detailVisible: false,
    planurlVisible: false,
    tableData1: [],
    id: "",
    detailTable: [],
    detailDate: {},
    detailInfo: [],
    detailTab: [],
    active: 0,
    bgInfo: [],
    planUrl: "",
    serviceRecordArr: [],
    infoDetail: {},
    link: "",
    all:{}
  }),

  components: {},
  created() {
    vm = this;
    this.id = this.$route.query.id;
    this.getCustomerInfo();
    this.queryServiceRecord();
    this.all = this.$tools.getLocal("all");
  },
  methods: {
    objectSpanMethod: function ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 6 || columnIndex === 7) {
        return {
          rowspan: vm.tableData1.length,
          colspan: 1,
        };
      } else {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
    },
    planDetail: function (id) {
      this.$http({
        url: "/master/paymentPlan/detail",
        type: "get",
        params: {
          id: id,
        },
      }).then(function (data) {
        vm.detailTable = [];
        vm.detailTable.push(data.data);
        vm.detailDate = data.data;
        vm.planUrl = data.data.planUrl;
        console.log(vm.planUrl);

        if (vm.detailDate.planUrl) {
          vm.getPlanDetail(vm.id);
        }
      });
    },
    planurlVisibleChange: function () {
      vm.planurlVisible = true;
      vm.plandz = "";
    },
    getPlanDetail: function (id) {
      this.$http({
        url: "/master/paymentPlan/getPlanDetail",
        type: "get",
        params: {
          id: id,
        },
      }).then(function (data) {
        vm.detailTab = [];
        for (var i = 0; i < data.data.length; i++) {
          vm.detailTab.push(data.data[i].userName);
          if (data.data[0].policyInfoList.length > 0) {
            data.data[0].policyInfoList[0].totalAmount =
              data.data[0].totalAmount;
            data.data[0].policyInfoList[0].totalPremium =
              data.data[0].totalPremium;
          }
        }
        vm.tableData1 = data.data[0].policyInfoList;
        vm.bgInfo = data.data;
        console.log(vm.bgInfo);
        // if (vm.detailDate.planUrl && vm.detailDate.authorizedState == "true") {
        //   vm.codes();
        // }
      });
    },
    queryServiceRecord: function () {
      this.$http({
        url: "/master/paymentPlan/queryServiceRecord",
        type: "get",
        params: {
          id: vm.id,
        },
      }).then(function (data) {
        vm.serviceRecordArr = data.data;
      });
    },
    getCustomerInfo: function () {
      let loadingInstance = Loading.service();
      this.$http({
        url: "/master/paymentPlan/getCustomerInfo",
        type: "get",
        params: {
          id: vm.id,
        },
      }).then(function (data) {
        loadingInstance.close();
        vm.infoDetail = data.data;
        vm.detailVisible = true;
      });
    },
    tabChange: function (index) {
      vm.active = index;
      for (var i = 0; i < vm.bgInfo.length; i++) {
        if (vm.bgInfo[index].policyInfoList.length > 0) {
          vm.bgInfo[index].policyInfoList[0].totalAmount =
            vm.bgInfo[index].totalAmount;
          vm.bgInfo[index].policyInfoList[0].totalPremium =
            vm.bgInfo[index].totalPremium;
        }
      }
      vm.tableData1 = vm.bgInfo[index].policyInfoList;
    },
    codes: function () {
      var canvas = document.getElementById("code");
      QRCode.toCanvas(canvas, vm.planUrl, function (error) {
        if (error) console.error(error);
        console.log("ssss!");
      });
    },
    sbmtPlan: function () {
      if (vm.plandz.indexOf("http") != 0 && vm.plandz.indexOf("HTTP") != 0) {
        this.$message.error("请输入带‘http’链接");
        return;
      }
      this.$http({
        url: "/master/paymentPlan/savePlanUrl",
        type: "post",
        params: {
          id: vm.id,
          planUrl: vm.plandz,
        },
      }).then(function (data) {
        vm.infoDetail = data.data;
        vm.planurlVisible = false;
        vm.planDetail(vm.id);
      });
    },
    planopen: function () {
      this.getPlanUrl();
    },
    getPlanUrl() {
      this.$http({
        url: "/master/subscribeService/getPlanUrl",
        type: "put",
        params: {},
      }).then((res) => {
        this.link = res.data;
        var canvas = document.getElementById("planCan");
        QRCode.toCanvas(canvas, this.link, function (error) {
          if (error) console.error(error);
          console.log("success!");
        });
      });
    },
    copy: function () {
      var clipboard = new Clipboard(".copy", {
        text: function () {
          return vm.link;
        },
      });
      clipboard.on("success", function (e) {
        vm.$message({
          message: "复制成功",
          type: "success",
        });
        clipboard.destroy();
      });
    },
  },
  mounted() {
    vm.planDetail(this.id);
  },
};
</script>
<style lang="scss">
.cmzDetail {
  background: #fff;
  padding: 27px 30px;
  font-size: 14px;
  min-height: calc(100vh - 80px);
  .list-empty {
    height: 200px;
    padding: 0;
  }
  .recored {
    width: 700px;
    margin-left: 30px;
    .item {
      display: flex;
      align-items: center;
      margin-top: 20px;
      font-size: 14px;
      position: relative;

      &:first-child {
        margin-top: 0;
      }
      .dot {
        width: 15px;
        height: 15px;
        background: #c7c7c7;
        border-radius: 50%;
      }
      .time {
        color: #888;
        margin-left: 4px;
        margin-right: 30px;
        width: 150px;
      }
      .status {
        color: #333333;
        font-size: 16px;
      }
      &.active {
        &:after {
          position: absolute;
          content: "";
          left: 7px;
          bottom: -10px;
          top: 20px;
          width: 1px;
          height: 16px;
          background: #c7c7c7;
        }
        &.hideLine::after{
          display: none;
        }
        .dot {
          background: #fd9201;
        }
        .time {
          color: #fd9201;
        }
        .status {
          color: #fd9201;
          font-size: 16px;
        }
      }
    }
  }
  .headTitle {
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 15px;
    margin-top: 30px;
    img {
      margin-right: 7px;
    }
  }
  .card {
    padding: 22px 28px;
    border: 1px solid #e9e9e9;
    margin-bottom: 10px;
    .row{
      .cell{
        display: inline-block;
        width: 25%;
        @media screen and(max-width:1440px){
          width: 33.3%;
        }
        &:not(:nth-last-child(-n+4)){
          margin-bottom: 17px;
        }
        span:nth-child(1) {
          text-align: right;
          color: #888888;
          margin-right: 22px;
          width: 85px;
          display: inline-block;
        }
        span:nth-child(2) {
          text-align: left;
          color: #333333;
        }
      }
    }
    .el-col {
      
    }
  }
}
</style>
